import { Title, Stack, Image } from '@mantine/core';
import { BaseLayout } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import WallForming from 'app/assets/wallforming.jpeg';
import { WallFormingBaseRoute } from 'app/modules/Routes';

export const Home = () => {
    const { t } = useTranslation();

    return (
        <BaseLayout
            className="bg-background-gray-ultra-ultra-light"
            environment={import.meta.env.VITE_ENVIRONMENT}
            innerClassName="h-full p-6"
            versionNumber={APP_VERSION}
            withCookieBanner={false}
        >
            <Stack align="center">
                <Title my="xl" order={4}>
                    {t('home')}
                </Title>
                <div className="flex gap-xl flex-wrap justify-center">
                    <Link
                        className="card border-border-ultra-light hover:card-clickable flex flex-row"
                        to={`/${WallFormingBaseRoute}`}
                    >
                        <Stack>
                            <Image src={WallForming}/>
                            <Title className="mt-4" order={4} ta="center">
                                {t('titleWallForming')}
                            </Title>
                        </Stack>
                    </Link>
                </div>
            </Stack>
        </BaseLayout>
    );
};
